angular.module('impactx.controlChip').controller('ControlChipCtrl', [
    '$scope',
    '$timeout',
    'TranslationService',
    '$mdPanel',
    '$element',
    'dataGen',
    'BasketAdHocControlStructureService',
    '$mdDialog',
    'AppConfiguration',
    ControlChipCtrl]);

function ControlChipCtrl($scope, $timeout, TranslationService, $mdPanel, $element, dataGen, BasketAdHocControlStructureService, $mdDialog, AppConfiguration) {
    var self = this;

    var maxValue = 100;
    if ($scope.directSplitting && $scope.directSplitMaxValue) {
        maxValue = $scope.directSplitMaxValue * 100
    }

    $scope.showDistribButton = AppConfiguration.get('showDistributeAccountingButton');
    $scope.autoDistrib = AppConfiguration.get('enableAutoAccountingDistribution');
    $scope.useHelperDialog = AppConfiguration.get('useAccountingHelper') && !($scope.maxNumber && $scope.maxNumber > 0);
    $scope.factorLabel = TranslationService.get('controlPercentInput');

    $scope.searchText = "";
    $scope.showedOnce = false;
    $scope.searchResults = 50;
    $scope.activeElement = null;
    $scope.additionalDataArray = [];

    $scope.showInput = function () {
        return false;
    };

    $timeout(function () {
        $scope.showInput = function () {
            return $scope.materialDesignInitForInputsDone && $scope.control && $scope.control.length > 1;
        };
    });

    $scope.removeChip = function (index) {
        var distribution = $scope.control;
        var length = distribution.length;
        var equal = equalValue(length - 1);
        var total = 0;
        var maxIter = length - 1;

        checkMarkAsChanged();

        if (index + 1 === length) {
            //last item deleted
            maxIter = maxIter - 1;
        }
        if ($scope.autoDistrib) {
            for (var i = 0; i < maxIter; i++) {
                if (i != index) {
                    distribution[i].factor = equal;
                    total = total + equal;
                }
            }
            if (maxIter > -1) {
                distribution[maxIter].factor = remainderValue(total);
            }
            $scope.dialogData[$scope.name].$setValidity("invalidFactors", true);
        }
    };
    $scope.transformChip = function (chip) {
        var setCtrls = $scope.control.filter(function (obj) {
            return obj.id === chip.id;
        });
        if (setCtrls.length === 0) {
            if ($scope.maxNumber && $scope.maxNumber > 0 && $scope.maxNumber <= $scope.control.length) {
                $scope.control.splice($scope.maxNumber - 1, $scope.control.length);
            }
            chip.factor = 1;
            if(!$scope.useHelperDialog && !$scope.autoDistrib && $scope.control.length >= 1)
            {
                chip.factor = 0;
            }
            if ($scope.autoDistrib) {
                var distribution = $scope.control;
                var length = distribution.length;
                var equal = equalValue(length + 1);
                var total = 0;
                for (var i = 0; i < length; i++) {
                    distribution[i].factor = equal;
                    total = total + equal;
                }
                chip.factor = remainderValue(total);
            }
        }
        else {
            chip = setCtrls[0];
        }

        return chip;
    };

    $scope.querySearch = function (query) {
        if ($scope.isAsync) {
            return $scope.getEntries(query);
        }
        if ($scope.showedOnce) {
            return query ? $scope.allowed.entries.filter($scope.createFilterFor(query)) : $scope.allowed.entries;
        }
        else {
            return $timeout(function () {
                var results = $scope.allowed.entries ? $scope.allowed.entries.slice(0, $scope.searchResults) : [];
                if ($scope.allowed.entries.length > $scope.searchResults) {
                    results.push({id: -1, value: TranslationService.get("moreResults")});
                }
                $scope.showedOnce = true;
                return results;
            });
        }
    };

    $scope.loadMore = function (event, item) {
        if (item.id < 0) {
            event.stopPropagation();
        }
    };

    $scope.createFilterFor = function (query) {
        var lowercaseQuery = query.toLowerCase();
        return function filterFn(control) {
            var itemText = $scope.formatItemText(control).toLowerCase();
            return (itemText.indexOf(lowercaseQuery) >= 0);
        };
    };

    $scope.setEqualDistribution = function (buttonPress) {
        if (buttonPress || $scope.autoDistrib) {
            var distribution = $scope.control;
            var length = distribution.length;
            var equal = equalValue(length);
            var total = 0;
            var hasBudget = false;
            for (var i = 0; i < length - 1; i++) {
                distribution[i].factor = equal;
                total = total + equal;
                if (distribution[i].hasBudget) {
                    hasBudget = true;
                }
            }
            distribution[i].factor = remainderValue(total);
            $scope.dialogData[$scope.name].$setValidity("invalidFactors", true);
            checkMarkAsChanged();
        }
        else {
            $scope.checkFactors();
        }
    };

    $scope.openHelperDialog = function (event) {
        if ($scope.helperDialogParams) {
            $mdDialog.show({
                controller: 'AccountingHelperCtrl',
                controllerAs: 'helperCtrl',
                templateUrl: 'modules/control/templates/basket-control-structure-helper.dialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    params: $scope.helperDialogParams,
                    current: JSON.parse(JSON.stringify($scope.control))
                }
            }).then(function (answer) {
                $scope.control = answer;
                $scope.checkFactors();
            })
        }
    };

    $scope.onAdd = function ($chip, $index) {
        if ($scope.onAddFunc){
            $scope.onAddFunc();
        }
        if ($scope.useHelperDialog && $chip && $index > 0) {
            $scope.openHelperDialog();
        }

        if ($scope.name.toUpperCase().indexOf("CTU") == -1) {
            inputBlur();
        }
        checkMarkAsChanged();
    };

    $scope.checkFactors = function () {
        if ($scope.control && $scope.control.length > 1) {
            var total = 0;
            for (var i = 0; i < $scope.control.length; i++) {
                total += $scope.control[i].factor * 100;
            }
            $scope.dialogData[$scope.name].$setValidity("invalidFactors", total === maxValue)
        }
        else {
            $scope.dialogData[$scope.name].$setValidity("invalidFactors", true)
        }
    };

    function checkMarkAsChanged() {
        if ($scope.markDialogChangedFunc) {
            $scope.markDialogChangedFunc({isValid: $scope.dialogData[$scope.name].isValid})
        }
    }

    $scope.openNewControlPanel = function (event) {
        BasketAdHocControlStructureService.openPanel(event,
            {label: $scope.label, identifier: $scope.name},
            $scope.trns,
            function (a, newControl) {
                if (newControl) {
                    $scope.allowed.entries.push(newControl);
                    if ($scope.name.toUpperCase().indexOf("CTU") >= 0) {
                        newControl.factor = 0;
                        $scope.control.push(newControl);
                    }
                    else {
                        $scope.control[0] = newControl;
                    }
                    if ($scope.autoDistrib) {
                        $scope.setEqualDistribution();
                    }
                    $scope.saveBasketFunction();
                }
            }
        );
    };

    /**
     * Function needed to refocus the autocomplete. This is needed because angular material
     * focuses the first input, which can be a percent input. In this case we need to refocus
     * the autocomplete. See also wiki entry related in IOBL-3937.
     * @param $event the current event.
     */
    $scope.reFocusAutocomplete = function ($event) {
        var activeElement = document.activeElement;
        if ($scope.activeElement != null && !$scope.selectedPercentInputFromAutoComplete) {
            //active element existing and we did not click a percent input element.
            var allInputs = $element[0].querySelectorAll('input');
            var input = allInputs[allInputs.length - 1];
            if (input.id === $scope.activeElement.id) {
                //active element was the autocomplete. Refocus it.
                input && input.focus();
            }
        }
        $scope.activeElement = activeElement;
        $scope.selectedPercentInputFromAutoComplete = false;
    };

    /**
     * Function needed for the function "$scope.reFocusAutocomplete". This sets a flag that the
     * @param $event the current event.
     */
    $scope.clickPercentInput = function ($event) {
        $event.stopPropagation();
        var activeElement = document.activeElement;

        if (activeElement != null && activeElement.id) {
            //set flag, so we can check it in focusLast function.
            $scope.selectedPercentInputFromAutoComplete = true;
        }
        var element = angular.element($event.target)[0];
        element && element.focus();
    };

    /**
     * Function needed for the function "$scope.reFocusAutocomplete". This sets only the active element
     * to the autocomplete.
     * @param $event the current event.
     */
    $scope.focusAutocomplete = function ($event) {
        //set the active element to the autocomplete, so we can check if we need to refocus it.
        $scope.activeElement = document.activeElement;
        $scope.focusedElement = angular.element($event.target);
    };

    $scope.setAdditionalDataArray = function () {
        $scope.additionalDataArray = $scope.fixedParamsFunc ? $scope.fixedParamsFunc() : [];
        $scope.additionalDataArray.push({field: 'type', value: $scope.type});
    };

    $scope.formatItemText = function (entry) {
        if (entry.name) {
            return entry.value + ' ' + entry.name;
        } else {
            return entry.value;
        }
    };

    $scope.getItemText = function (entry) {
        if (entry && entry.value) {
            return $scope.formatItemText(entry);
        }
        else {
            $scope.searchText = '';
            return '';
        }
    };

    $scope.getEntries = function (searchText) {
        var dataObject = {searchText: searchText};
        $scope.setAdditionalDataArray();
        if ($scope.additionalDataArray) {
            var i = 0;
            while (i < $scope.additionalDataArray.length) {
                if ($scope.additionalDataArray[i].value) {
                    dataObject[$scope.additionalDataArray[i].field] = $scope.additionalDataArray[i].value;
                }
                else if ($scope.additionalDataArray[i].valueFunction) {
                    dataObject[$scope.additionalDataArray[i].field] = $scope.additionalDataArray[i].valueFunction();
                }
                i++;
            }
        }
        if ($scope.entryPoint) {
            return dataGen.getData({}, dataObject, $scope.entryPoint, null, true).then(function (data) {
                if (data && data.data) {
                    return $scope.extractData(data);
                }
                return [];
            });
        }
        return [];
    };

    var idForLoadMore = -2;
    $scope.extractData = function (data) {
        var results = [];
        if ($scope.showedOneTime) {
            return data.data.entries;
        }
        else {
            results = results.concat(data.data.entries.slice(0, $scope.searchResults));
            if (data.data.entries.length > $scope.searchResults) {
                results.push({id: idForLoadMore, value: TranslationService.get("moreResults")});
            }
            $scope.showedOneTime = true;
            return results
        }
    };

    function inputBlur() {
        if ($scope.activeElement) {
            $scope.showSuggestions = true;

            $timeout(function () {
                $scope.activeElement.blur();
                $scope.focusedElement.blur();
                var chipsElement = $element.find('md-chips');
                var chipController = chipsElement.controller('mdChips');
                if (chipController) {
                    chipController.onInputBlur();
                }

                $scope.showSuggestions = false;
            }, 600);
        }
    }

    function equalValue(length) {
        var fracSize = $scope.fractionSize || 2;
        return Math.round((maxValue / length) * Math.pow(10, fracSize)) / Math.pow(10, fracSize+2);
    }

    function remainderValue(total) {
        var fracSize = $scope.fractionSize || 2;
        return Math.round((maxValue - total * 100) * Math.pow(10, fracSize)) / Math.pow(10, fracSize+2);
    }
}
